
import { ValidationProvider, ValidationObserver, extend, localize } from 'vee-validate'
import { required, email } from 'vee-validate/dist/rules'
import ja from 'vee-validate/dist/locale/ja.json'
import Vue from 'vue'

import FormCard from '~/components/molecules/FormCard.vue'
import Button from '~/components/atoms/Button.vue'
import InputBox from '~/components/molecules/InputBox.vue'
import Separator from '~/components/atoms/Separator.vue'
import Alert from '~/components/atoms/Alert.vue'
import AuthContainer from '~/components/organisms/AuthContainer.vue'

import { AuthApiUrl } from '~/server/api/route/url'

localize('ja', ja)

extend('email', {
  ...email,
})
extend('required', {
  ...required,
})
export default Vue.extend({
  components: {
    FormCard,
    Button,
    InputBox,
    Separator,
    ValidationObserver,
    ValidationProvider,
    Alert,
    AuthContainer,
  },
  layout: 'public',
  data() {
    return {
      error: null,

      issueForm: {
        email: '',
      },
    }
  },
  methods: {
    async issueCode() {
      const email = this.$data.issueForm.email
      try {
        await this.$axios.$post(AuthApiUrl.ISSUE_RESET_CODE, { email })
        window.location.href = `/discover_sexualities/auth/reset/password/verify/code`
      } catch (e) {
        this.$data.error = 'メールを送信できませんでした'
      }
    },
  },
})
